import { connect } from 'react-redux';
import { getUserRole, getShopKind } from '../selectors';

const mapStateToProps = state => ({
  role: getUserRole(state),
  shopKind: getShopKind(state),
});

export default connect(mapStateToProps);

